import '../Sidebar/Sidebardigital';
import Sidebarfarmer from '../Sidebar/Sidebarfarmer';
import Sidebarblank from '../Sidebar/Sidebarblank';
import React from 'react';
import Payback from '../images/payback.png';
export default function Farmer()
{
    return(
       <>
      <div className="row">
        <div className="col-2 custom-display">
          <Sidebarfarmer />
        </div>
        <div className="col-8 custom-width">

            <br></br><br></br>
            <ui><h2>Green farm a cost effection option</h2><br></br></ui>
        <p1>Our objective is to increase awareness among farmers for the innovative agriculture approaches and technologies. These innovative technologies are either helps farmers to reduce the input cost OR help them to get higher yield/premium for their produce. 
<br></br><br></br>
Gatisheel first product is a retrofit option which will enable agri-electrial infra to a smarter one. With this solution, overall agri-electrical infra is available on farmer's mobile. Farmer can perform the # of functions from his mobile – 
<br></br><br></br>
<strong>•	Error codes direct on his mobile – current overload, over-voltage, under-voltage, phase failure.<br></br><br></br>
•	Motor burn protection – save upto 10K INR/year<br></br><br></br>
•	Power ON/OFF information<br></br><br></br>
•	Remote timer – Set remote timer from his mobile- clock based and time based. <br></br><br></br>
•	Remote operation – ON/OFF<br></br><br></br>
•	Pump Usage report – Daily/weekly/monthly reports</strong><br></br>
<br></br>
</p1><br></br>
<img src={Payback} className="img-fluid" alt="Why Gatisheel" loading="lazy" width="100%" height="auto" />
<br></br><br></br>
<p>Payback period of this device is 9 months. And 3 year is the overall life time of this device. </p>
        <br/><br/>


        </div>
        <div className="col-2 custom-display">
          <Sidebarblank />
        </div>
        </div>
     </>
    )   
   };